var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.marketBannerAdv},[_c('div',{class:[_vm.$style.bannerBox, _vm.isLoading && _vm.$style.loading],style:({
      height: _vm.advData.marketHeight,
      width: _vm.advData.marketWidth,
    }),on:{"click":function($event){_vm.advLinkJump(_vm.advData.marketUrl)}}},[_c('img',{class:_vm.$style.image,attrs:{"src":_vm.advData.marketSource},on:{"load":_vm.closeLoading,"error":_vm.closeLoading}})])])}
var staticRenderFns = []

export { render, staticRenderFns }